import React from 'react';
import styles from './command-bar.module.css';

const CHIP_CONFIG = {
  person:     { className: styles.chipPerson, icon: '👤' },
  org:        { className: styles.chipOrg, icon: '🏢' },
  fund:       { className: styles.chipFund, icon: '💰' },
  education:  { className: styles.chipEducation, icon: '🎓' },
  engagement: { className: styles.chipEngagement, icon: '💼' },
  region:     { className: styles.chipRegion, icon: '📍' },
};

const ContextChipBar = ({ contexts, onRemove }) => {
  if (!contexts || contexts.length === 0) return null;

  return (
    <div className={styles.chipBar}>
      {contexts.map((ctx, i) => {
        const config = CHIP_CONFIG[ctx.label] || CHIP_CONFIG.person;
        const display = ctx.displayValue || ctx.name || ctx.value || ctx.id;
        return (
          <span key={ctx.id || `${ctx.label}-${i}`} className={`${styles.chip} ${config.className}`}>
            {config.icon} {display}
            <button onClick={() => onRemove(ctx)} aria-label={`Remove ${display}`}>✕</button>
          </span>
        );
      })}
    </div>
  );
};

export default ContextChipBar;
